<script>
  import {
    toggleBold,
    toggleItalic,
    toggleStrike,
    toggleUnderline,
  } from "./buttonActions.js"
  import Button from "./Button.svelte"

  export let editor
</script>

{#if editor}
  <div class="fixed-menu bg-light">
    <Button {editor} key="bold" on:click={() => toggleBold(editor)}>
      <i class="bi bi-type-bold" />
    </Button>
    <Button {editor} key="italic" on:click={() => toggleItalic(editor)}>
      <i class="bi bi-type-italic" />
    </Button>
    <Button {editor} key="strike" on:click={() => toggleStrike(editor)}>
      <i class="bi bi-type-strikethrough" />
    </Button>
    <Button {editor} key="underline" on:click={() => toggleUnderline(editor)}>
      <i class="bi bi-type-underline" />
    </Button>
  </div>
{/if}

<style>
  .fixed-menu {
    padding: 2px;
    min-height: 36px;
  }
</style>
